<template>
  <div class="inputdropdown mw-100">
    <slot name="input" />

    <transition-group
      tag="ul"
      :class="dynamicClass"
      class="inputdropdown__items overflow-hidden mw-0"
    >
      <slot name="fixedItems" />

      <li
        v-for="(item, index) in filteredData"
        :key="item.name"
        :data-index="index"
        data-grid
        class="inputdropdown__item grid--va-stretch cursor-pointer px-3 overflow-hidden"
        @click="$emit('valueInputDropDown', item)"
      >
        <span
          data-grid
          class="inputdropdown__item-description grid--va-center my-2"
        >
          {{ item.description }}
        </span>

        <strong
          data-grid
          class="inputdropdown__item-name grid--va-center grid--center my-2"
        >
          {{ item.name }}
        </strong>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'InputDropDown',

  props: {
    data: {
      type: Array,
      required: true,
      validator (v) {
        return Array.isArray(v)
      }
    },

    showing: Boolean,

    value: {
      type: String,
      default: () => ''
    }
  },

  emits: ['valueInputDropDown'],

  computed: {
    dynamicClass () {
      return {
        focused: this.showing
      }
    },

    filteredData () {
      const { value, data } = this

      if (!value.length) return data

      return data.filter(item => {
        const { name, description } = item

        return [name, description].some(text => text.toLowerCase().includes(value.toLowerCase()))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .inputdropdown {
    --borderWidth: 2px;
    --borderColor: rgb(var(--gray1));

    &__items {
      border-radius: 0 0 8px 8px;
      padding: calc(var(--borderWidth));
      margin: calc(var(--borderWidth) * 2 * -1) 0 0;
      transition: max-height .4s ease-in-out;

      &.focused {
        max-height: 295px;
      }
    }

    &__item {
      height: 62px;

      &:last-of-type {
        border-radius: 0 0 8px 8px;
      }

      &:nth-child(even) {
        background-color: rgb(var(--gray6));
      }

      &:nth-child(odd) {
        background-color: rgb(var(--white));
      }

      &-name {
        flex: 0 0 30%;
        font: 700 1.2rem "Nunito", sans-serif;
      }

      &-description {
        flex: 0 0 70%;
        font: 500 1.4rem "Nunito", sans-serif;
      }
    }

    .is-dark-theme & {
      &__items li:first-of-type {
        margin: 2px 0 0;
      }

      &__create {
        background-color: red;
      }

      &__items {
        background-color: var(--borderColor);
      }

      &__item {
        color: rgb(var(--gray4));

        &:nth-child(even) {
          background-color: rgb(var(--gray8));
        }

        &:nth-child(odd) {
          background-color: rgba(var(--gray8), .9);
        }
      }
    }
  }
</style>
